<script>
    import { createEventDispatcher, afterUpdate } from 'svelte';
    import { fade } from 'svelte/transition'

    const dispatch = createEventDispatcher();

    export let isOpenModal;
    export let darkmode;

    function closeModal() {
        isOpenModal = false;
        dispatch('closeModal', { isOpenModal });
    }

    afterUpdate(() => {
        if(isOpenModal){
            document.getElementById('playnow').focus();
        }
    })
</script>

{#if isOpenModal}
<div id="background" on:click={closeModal} transition:fade></div>
<div id="modal" transition:fade>
    <h5>How to Play</h5>
    <p>Use the clues to fill in the 3 word couplets in the ampersandi.</p>
    <p>
        All the words to the left of the ampersands rhyme with each other and 
        the same goes for the words to the right. 
    </p>
    {#if darkmode}
        <img src="images/info-explain-dark2.png" alt="example showing completed couplet 'rise & shine', completed couplet 'sighs & fine' and incomplete couplet 'pies & wine'" class="explainer explainer-dark">
    {:else}
        <img src="images/info-explain-light2.png" alt="example showing completed couplet 'rise & shine', completed couplet 'sighs & fine' and incomplete couplet 'pies & wine'" class="explainer explainer-light">
    {/if}
    <p>
        If you guess a couplet correctly, it will lock in place. Keep guessing until solved. Get more help <a href="https://www.pillboxgames.com/ampersandi" target="_blank" aria-label="link to full instructions">here</a>.
    </p>
    <button id="playnow" type="button" class="submitbtn" on:click={closeModal}>Play Now</button>
</div>
{/if}

<style>
    #background {
        display: block;
        position: fixed;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: var(--fg-color);
        opacity: 0.6;
    }

    #modal {
        display: block;
        position: absolute;
        padding:15px;
        z-index: 12;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: var(--bg-color);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        max-width:300px;
        width:100%;
    }
    h5 {
        font-family: 'Georgia';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.18em;
        margin-top: 5px;
        margin-bottom: 5px;
        color: var(--fg-color);
        padding-top:0px;
    }
    p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 27px;

        color: var(--fg-color);
    }
    img.explainer{
        width:100%;
    }
    img.explainer-dark{
        filter:invert(0);
    }
    a {
        color:var(--accent);
    }
    a:hover {
        color:var(--accent);
    }
</style>